import * as CookieConsent from "vanilla-cookieconsent";

export default defineNuxtPlugin(async (nuxtApp) => {
  const { initialize, enableAnalytics, disableAnalytics } = useGtag();
  const router = useRouter();

  if (router.currentRoute.value.path === "/embed") {
    return {
      provide: {
        CC: CookieConsent,
      },
    };
  }

  await CookieConsent.run({
    guiOptions: {
      consentModal: {
        layout: "box",
        position: "middle center",
      },
      preferencesModal: {
        layout: "box",
      },
    },
    disablePageInteraction: true,

    onFirstConsent: () => {},

    onConsent: ({ cookie }) => {
      const hasAnalyticsConsent = cookie.categories.includes("analytics");
      if (hasAnalyticsConsent) {
        initialize();
      } else {
        disableAnalytics();
      }
    },

    onChange: ({ cookie }) => {
      const hasAnalyticsConsent = cookie.categories.includes("analytics");
      if (hasAnalyticsConsent) {
        initialize();
        enableAnalytics();
      } else {
        disableAnalytics();
      }
    },

    categories: {
      necessary: {
        readOnly: true,
        enabled: true,
      },
      analytics: {
        enabled: true,
        autoClear: {
          cookies: [
            {
              name: /^(_ga|_gid|_gat|_gac_.*|__utma|__utmb|__utmc|__utmt|__utmz|_dc_gtm_.*|_gtm_.*)/,
            },
            {
              name: /^(jwplayer\.|jw-|jwpltx\.|jwpseg\.|__jwpusr)/,
            },
          ],
        },
      },
    },

    language: {
      default: "en",

      translations: {
        en: {
          consentModal: {
            title: "PokerGO Cookie Consent",
            description:
              "PokerGO and our service providers may use cookies, pixels, and similar tools (collectively, “cookies”) to collect and record information about you, including your browsing activities and devices. Some cookies are necessary for our website to function and cannot be switched off, even if the “Reject All” option is selected below. Other optional cookies improve the website experience and/or are used for analytics or targeted advertising. By clicking “Accept All” you agree to the use of these optional cookies to collect and disclose your information in accordance with our Privacy Policy and Terms of Use, which may be viewed by clicking here: <br>\n" +
              `                <div style='text-align: center;display: block'><a href='/privacy-policy' target='_blank' style=" color: yellow; text-decoration-line: underline;">Privacy Policy</a>\n` +
              `    <a href="/terms-of-use" target="_blank" style=" color: yellow; text-decoration-line: underline;">Terms of Use</a></div>\n` +
              "                You may also customize which optional cookies are used by clicking on “Customize” below.",
            acceptAllBtn: "Accept All",
            acceptNecessaryBtn: "Reject All",
            showPreferencesBtn: "Customize",
            // closeIconLabel: 'Reject all and close modal',
          },
          preferencesModal: {
            title: "Manage cookie preferences",
            acceptAllBtn: "Accept all",
            acceptNecessaryBtn: "Reject all",
            savePreferencesBtn: "Accept current selection",
            closeIconLabel: "Close modal",
            serviceCounterLabel: "Service|Services",
            sections: [
              {
                title: "Privacy Preference Center",
                description: `<div>When you visit any website, it may store or retrieve information on your browser or device through cookies, pixels, or similar technologies (collectively, "cookies"). This information might be about you, your preferences, or your device. The information does not usually directly identify you, but it can give you a more personalised experience. Please reference the descriptions below to learn more about optional cookies and use the corresponding toggles to opt in. Your experience of the site and services may be impacted where certain optional cookies are turned off. Please also note that your cookie choices are specific to the particular browser or device that you are using when you exercise that choice, so you may need to separately exercise those choices for each type of browser or device you use to visit the site and services.</div><br/><br/><div>Full list of cookies used on our website is included in our  <a href="/privacy-policy" target="_blank" style="text-decoration: underline;color: yellow">privacy policy</a></div>`,
              },
              {
                title: "Strictly Necessary",
                description:
                  "These cookies are necessary for the website to function and cannot be switched off in our systems. They may enable the disclosure of your information to some of our business partners, but are usually only set in response to actions made by you which amount to a request for services, such as setting your privacy preferences, logging in or filling in forms. You can set your browser to block or alert you about these cookies, but some parts of the site will not then work. If you do not agree to the use and disclosure of your information pursuant to these cookies you should not use the website.",

                //this field will generate a toggle linked to the 'necessary' category
                linkedCategory: "necessary",
              },
              {
                title: "Marketing and Analytics",
                description:
                  "These cookies help us and our marketing and analytics partners understand how visitors engage with our site. They allow us to track traffic sources, user behavior, and content performance so we can optimize our marketing efforts and enhance user experience. Disabling these cookies limits our ability to measure campaign effectiveness and understand what content resonates most with our audience.",
                linkedCategory: "analytics",
              },
            ],
          },
        },
      },
    },
  });

  return {
    provide: {
      CC: CookieConsent,
    },
  };
});
